// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_selections.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { AccessReviewSelectionRef } from "./accessreview";
import { AccessReviewSelectionState } from "./accessreview";
import { Any } from "../../../../google/protobuf/any";
import { AccessReviewSelectionView } from "./accessreview";
import { AccessReviewSelectionExpandMask } from "./accessreview";
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest
 */
export interface AccessReviewSelectionsServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewSelectionExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse
 */
export interface AccessReviewSelectionsServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionView list = 1
     */
    list: AccessReviewSelectionView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest
 */
export interface AccessReviewSelectionsServiceAddRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string entitlement_ids = 3
     */
    entitlementIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse
 */
export interface AccessReviewSelectionsServiceAddResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest
 */
export interface AccessReviewSelectionsSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_ids = 5
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionState selection_states = 6
     */
    selectionStates: AccessReviewSelectionState[];
    /**
     * @generated from protobuf field: repeated string application_ids = 7
     */
    applicationIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask = 8
     */
    expandMask?: AccessReviewSelectionExpandMask;
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 9
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 10
     */
    complianceFrameworkIds: string[];
    /**
     * @generated from protobuf field: repeated string data_type_ids = 11
     */
    dataTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string data_classification_ids = 12
     */
    dataClassificationIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionRef refs = 13
     */
    refs: AccessReviewSelectionRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse
 */
export interface AccessReviewSelectionsSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionView list = 1
     */
    list: AccessReviewSelectionView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4
     */
    facets?: Facets;
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceListRequest$Type extends MessageType<AccessReviewSelectionsServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewSelectionExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionsServiceListRequest>): AccessReviewSelectionsServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionsServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionsServiceListRequest): AccessReviewSelectionsServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewSelectionExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionsServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewSelectionExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest
 */
export const AccessReviewSelectionsServiceListRequest = new AccessReviewSelectionsServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceListResponse$Type extends MessageType<AccessReviewSelectionsServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSelectionView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionsServiceListResponse>): AccessReviewSelectionsServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionsServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionsServiceListResponse): AccessReviewSelectionsServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewSelectionView list */ 1:
                    message.list.push(AccessReviewSelectionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionsServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewSelectionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewSelectionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse
 */
export const AccessReviewSelectionsServiceListResponse = new AccessReviewSelectionsServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceAddRequest$Type extends MessageType<AccessReviewSelectionsServiceAddRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionsServiceAddRequest>): AccessReviewSelectionsServiceAddRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.appId = "";
        message.entitlementIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionsServiceAddRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionsServiceAddRequest): AccessReviewSelectionsServiceAddRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* repeated string entitlement_ids */ 3:
                    message.entitlementIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionsServiceAddRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* repeated string entitlement_ids = 3; */
        for (let i = 0; i < message.entitlementIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest
 */
export const AccessReviewSelectionsServiceAddRequest = new AccessReviewSelectionsServiceAddRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceAddResponse$Type extends MessageType<AccessReviewSelectionsServiceAddResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse", []);
    }
    create(value?: PartialMessage<AccessReviewSelectionsServiceAddResponse>): AccessReviewSelectionsServiceAddResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionsServiceAddResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionsServiceAddResponse): AccessReviewSelectionsServiceAddResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionsServiceAddResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse
 */
export const AccessReviewSelectionsServiceAddResponse = new AccessReviewSelectionsServiceAddResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsSearchServiceSearchRequest$Type extends MessageType<AccessReviewSelectionsSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "selection_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AccessReviewSelectionState", AccessReviewSelectionState, "ACCESS_REVIEW_SELECTION_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 7, name: "application_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => AccessReviewSelectionExpandMask },
            { no: 9, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "data_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "data_classification_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 13, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSelectionRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionsSearchServiceSearchRequest>): AccessReviewSelectionsSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeIds = [];
        message.selectionStates = [];
        message.applicationIds = [];
        message.riskLevelIds = [];
        message.complianceFrameworkIds = [];
        message.dataTypeIds = [];
        message.dataClassificationIds = [];
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionsSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionsSearchServiceSearchRequest): AccessReviewSelectionsSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_ids */ 5:
                    message.excludeIds.push(reader.string());
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewSelectionState selection_states */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.selectionStates.push(reader.int32());
                    else
                        message.selectionStates.push(reader.int32());
                    break;
                case /* repeated string application_ids */ 7:
                    message.applicationIds.push(reader.string());
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask */ 8:
                    message.expandMask = AccessReviewSelectionExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string risk_level_ids */ 9:
                    message.riskLevelIds.push(reader.string());
                    break;
                case /* repeated string compliance_framework_ids */ 10:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                case /* repeated string data_type_ids */ 11:
                    message.dataTypeIds.push(reader.string());
                    break;
                case /* repeated string data_classification_ids */ 12:
                    message.dataClassificationIds.push(reader.string());
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewSelectionRef refs */ 13:
                    message.refs.push(AccessReviewSelectionRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionsSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_ids = 5; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* repeated c1.api.accessreview.v1.AccessReviewSelectionState selection_states = 6; */
        if (message.selectionStates.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.selectionStates.length; i++)
                writer.int32(message.selectionStates[i]);
            writer.join();
        }
        /* repeated string application_ids = 7; */
        for (let i = 0; i < message.applicationIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.applicationIds[i]);
        /* c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask = 8; */
        if (message.expandMask)
            AccessReviewSelectionExpandMask.internalBinaryWrite(message.expandMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string risk_level_ids = 9; */
        for (let i = 0; i < message.riskLevelIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.riskLevelIds[i]);
        /* repeated string compliance_framework_ids = 10; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        /* repeated string data_type_ids = 11; */
        for (let i = 0; i < message.dataTypeIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.dataTypeIds[i]);
        /* repeated string data_classification_ids = 12; */
        for (let i = 0; i < message.dataClassificationIds.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.dataClassificationIds[i]);
        /* repeated c1.api.accessreview.v1.AccessReviewSelectionRef refs = 13; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewSelectionRef.internalBinaryWrite(message.refs[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest
 */
export const AccessReviewSelectionsSearchServiceSearchRequest = new AccessReviewSelectionsSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsSearchServiceSearchResponse$Type extends MessageType<AccessReviewSelectionsSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSelectionView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionsSearchServiceSearchResponse>): AccessReviewSelectionsSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionsSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionsSearchServiceSearchResponse): AccessReviewSelectionsSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewSelectionView list */ 1:
                    message.list.push(AccessReviewSelectionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                case /* c1.api.search.v1.Facets facets */ 4:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionsSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewSelectionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewSelectionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        /* c1.api.search.v1.Facets facets = 4; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse
 */
export const AccessReviewSelectionsSearchServiceSearchResponse = new AccessReviewSelectionsSearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewSelectionsService
 */
export const AccessReviewSelectionsService = new ServiceType("c1.api.accessreview.v1.AccessReviewSelectionsService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSelectionsServiceListRequest, O: AccessReviewSelectionsServiceListResponse },
    { name: "Add", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewSelectionsServiceAddRequest, O: AccessReviewSelectionsServiceAddResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewSelectionsSearchService
 */
export const AccessReviewSelectionsSearchService = new ServiceType("c1.api.accessreview.v1.AccessReviewSelectionsSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSelectionsSearchServiceSearchRequest, O: AccessReviewSelectionsSearchServiceSearchResponse }
]);
